<template>
    <section class="publication">
        <div class="container">

            <div class="row">
                <div class="col-md-12">

                    <div class="publication__heading d-flex">
                        <publication-progress :step-info="{ info: currentStepComponent.progress, count: initial.length }" />
                        <h2 v-if="currentStepComponent">{{ currentStepComponent.title }}</h2>
                        <span v-if="currentStepComponent.subtitle" class="publication__subtitle">{{ currentStepComponent.subtitle }}</span>
                        <button v-if="!currentStepComponent.required" type="button" class="btn publication__btn"
                                @click.prevent="handleTransform('increment')"
                        >{{$store.getters.t('common_skip')}}</button>
                    </div>

                </div>
            </div>

            <div class="publication__content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="publication__slider" ref="slider" :style="{maxHeight: `${sliderHeight}px`}" >

                            <div class="publication__slider-track clearfix"
                                 :style="{width: `${trackWidth}px`, transform: `translateX(${trackTransform}px)`}">

                                <template v-if="initial.length">

                                    <template v-for="(s, idx) in initial">

                                        <div class="publication__slider-slide" ref="slides" :style="{width: `${slideWidth}px`}" :key="idx">
                                            <component :server="server" @parent-update="stepUpdate" ref="stepRefs" :is="s.component.name"></component>
                                        </div>

                                    </template>

                                </template>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-if="step < initial.length - 1">
                <div class="col-md-12">
                    <div class="publication__nav d-flex">
                        <button type="button" class="btn publication__btn publication__btn--primary"
                                @click.prevent="submitForm" :disabled="disableActionButton"
                        >
                            {{
                                (currentStepComponent.valid && !disableActionButton  && $store.getters.t('publication_submit_save_and_moderate')) ||
                                (disableActionButton && $store.getters.t('publication_submit_wait_check')) ||
                                $store.getters.t('publication_submit_fix_errors_retry')
                            }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

import SliderMixin from "../mixins/SliderMixin";
import StateMixin from "../mixins/StateMixin";

import createHomestays from "./createHomestays";

import PublicationProgress from '../PublicationProgress';
import PublicationSuccess from './PublicationSuccess';
import Homesatays from "./Homesatays";
import {paginationScrollTo} from "../../helpers/helpers";

export default {
    name: "index.vue",
    props: ['server'],
    mixins: [SliderMixin, StateMixin],
    components: {
        PublicationProgress, Homesatays, PublicationSuccess
    },
    data(){

        return{
            slides: createHomestays,
            merge_model: false,
            STORE_ENDPOINT:  this.server.model ? `/api/homestays/${this.server.model.id}?_method=PUT` : '/api/homestays',
        }

    },

    created() {

        this.CREATE_STATE_BY_KEY('homestays');

        if (
            this.server.model
            && Object.keys(this.server.model).length
            && window.location.pathname.search(/\/pet\/\d+$/g)
        ) {

            this.merge_model = true;

            const prepareState = {

                images: [],

                previewImages: this.server.model['images'].map( photo => {
                    return {
                        id: photo.id,
                        base64: '/storage' + photo.path,
                        name: (
                            (arr) => { return arr[ arr.length - 1 ] }
                        )(photo.path.split('/')),
                    }
                } ),

                selectedCity: { ...this.server.model.city },

                pet_categories: this.server.model.pet_categories.map( e => e.id )

            };


            Object.keys(this.GET_STATE).forEach( _k => {

                if ( ! this.server.model.hasOwnProperty( _k ) || prepareState.hasOwnProperty( _k ) ) return;

                prepareState[ _k ] = this.server.model[ _k ];

            });

            this.SET_STATE_BY_MODEL( prepareState )

        }
    },

    methods:{

        async submitForm(){

            this.disableActionButton = true;

            const valid = this.$refs.stepRefs[ this.step ].isValid()

            if ( ! valid ) {
                this.handleSliderHeight();
                this.disableActionButton = false;
            }

            if ( valid ){

                const success = await this.ACTION_STORE( this.STORE_ENDPOINT )

                if( success.success ) {

                    new Promise(res => {

                        paginationScrollTo('.publication__heading');
                        setTimeout(() => {
                            res();
                        }, 700)

                    }).then( () => {
                        this.handleTransform( 'increment' )
                        return this.slides[ this.step ].valid = success;
                    } )

                } else {
                    this.disableActionButton = false;

                    if (result && result.errors) {
                        for (let key in result.errors) {
                            var message = result.errors[key];
                            if (key.startsWith('images.') && message == 'The ' + key + ' failed to upload.') {
                                alert(this.$store.getters.t('publication_image_too_large_5mb'));
                            }
                            if(key == 'avatar' && message == ('The ' + key + ' failed to upload.')) {
                                alert(this.$store.getters.t('publication_avatar_too_large_5mb'));
                            }
                        }
                    }
                }


            }

        }

    }

}
</script>

<style scoped>

</style>
